import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { AssetWithLinkProps } from './asset-with-link.types';
import { ImageBlockContainer } from './asset-with-link.styles';
import { PAtom } from '@atoms/text-atoms/text-atoms';

const AssetWithLink: React.FC<AssetWithLinkProps> = ({
  description = '',
  alt = '',
  gatsbyImageData,
  imageSrc,
  format,
  linkUrl,
  openInNewTab,
}) => {
  if (!gatsbyImageData || !imageSrc) return null;

  const imageLink = linkUrl;

  const renderImage = (gatsbyImageData: any) => {
    const gatsbyImage = getImage(gatsbyImageData);

    const imageContent = (
      <>
        {gatsbyImage && format !== 'image/gif' && format !== 'image/svg+xml' ? (
          <GatsbyImage
            image={gatsbyImage}
            alt={alt || description || ''}
            className="gatsby-image-pos"
          />
        ) : (
          <div>
            {imageSrc && <img src={imageSrc} alt={alt || description || ''} />}
          </div>
        )}

        {description && <PAtom>{description}</PAtom>}
      </>
    );

    return imageContent;
  };

  return (
    <ImageBlockContainer data-testid={`image-with-link`}>
      {imageLink ? (
        <a
          href={imageLink}
          target={openInNewTab ? '_blank' : undefined}
          rel={openInNewTab ? 'noopener noreferrer' : undefined}
        >
          {renderImage(gatsbyImageData)}
        </a>
      ) : (
        renderImage(gatsbyImageData)
      )}
    </ImageBlockContainer>
  );
};

export default AssetWithLink;
